import TechnicianAppstore from './store/technician-app-store';
import { createApp } from 'vue';
import TechnicianPortalApp from './TechnicianPortalApp.vue';
import SkillAssessmentApp from './SkillAssessmentApp.vue';
import router from './router';
import storeRef from './store/instance';
// CSS
import './styles/fonts.scss';
import 'material-icons/iconfont/material-icons.css';
import 'bulma/css/bulma.css';
import './styles/main.scss';
import './styles/extention.scss';
import axiosInterceptors, { TokenStrategy } from './utils/axios-interceptors';
import initializeUtils from './utils/data-utils';
import { funnelsUtilsServices, init } from '@puls/puls-general-utils';
import config from './config';
import skillAssessmentAppStore from './store/skill-assessment-app-store';

init.updateParams({ 
	params: {
		config
	}
})

if (window.location.pathname === '/skill-assessment/quiz') {
	const app = createApp(SkillAssessmentApp)
	const token = getSkillAssessmentToken();
	if (!token) {
		document.body.innerHTML = "<h1>No Token Provided</h1>";
	} else {
		axiosInterceptors(skillAssessmentAppStore)({
			token_strategy: TokenStrategy.SkillAssessmentAppToken,
			token 
		});
		storeRef.init(skillAssessmentAppStore);
		app.use(skillAssessmentAppStore);
		app.mount('#app')
	}
} else {
	const app = createApp(TechnicianPortalApp)
	const noAuthJwt = config.noLoginApp;
	router.init({ jobsApp: !!noAuthJwt })
	initializeUtils.init(TechnicianAppstore);
	funnelsUtilsServices.insertGoogleTagManagerScript(window, document, 'script', 'dataLayer', 'GTM-PKCR89')
	axiosInterceptors(TechnicianAppstore)({ token_strategy: TokenStrategy.TechnicianAppToken });
	storeRef.init(TechnicianAppstore);
	app.use(TechnicianAppstore);
	app.use(router.instance);
	app.mount('#app')
}

function getSkillAssessmentToken (): string {
	let serverToken = ''
	try {
		serverToken = JSON.parse(document.getElementById('server-skill-assessment-token')?.innerText || '');
	} catch (error) {
		
	}
	const searchParams = new URLSearchParams(window.location.search);
	return serverToken || searchParams.get('token') || '';
}
